import { getNotebook } from '../api/queries/notebook';
import { fetch } from '../api/fetch';

export async function downloadNotebook(title: string) {
  const notebook = await getNotebook(title, fetch);
  const content = JSON.stringify(JSON.parse(notebook.content), null, 1);
  const blob = new Blob([content], { type: 'application/x-ipynb+json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = title.endsWith('.ipynb') ? title : `${title}.ipynb`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
